import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme, alpha } from '@mui/material/styles';
import './directories.css';

export default function DirectoryPage({ title, subtitle, actions, children, className = '', headingRef }) {
  const theme = useTheme();
  const { t } = useTranslation('directories');
  const tokens = {
    panel: theme.palette.background.paper, ground: theme.palette.background.default,
    ink: theme.palette.text.primary, muted: theme.palette.text.secondary,
    green: theme.palette.primary.main, line: theme.palette.divider,
    tint: alpha(theme.palette.primary.main, .12), hover: theme.palette.action.hover,
    'on-accent': theme.palette.mode === 'dark' ? '#172b21' : '#ffffff',
  };
  return <div className={`dr-page ${className}`} data-theme={theme.palette.mode} style={Object.fromEntries(
    Object.entries(tokens).map(([key, fallback]) => [`--dr-${key}`, `var(--dv-${key}, ${fallback})`])
  )}>
    <header className="dr-heading">
      <div><Link to="/dashboard" className="dr-back">{t('back')}</Link><h1 ref={headingRef} tabIndex={-1}>{title}</h1><p>{subtitle}</p></div>
      {actions && <div className="dr-heading-actions">{actions}</div>}
    </header>
    {children}
  </div>;
}
